module.exports = __webpack_public_path__ + "fonts/FuturaStd-Medium.8b6983e6.eot";